export default __webpack_public_path__ + "static/media/mobileUsers.3a1b82c6.png";